import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import ReactSlider from "react-slider";
import { styleBlock } from "../styleBlock";
// TODO: this needs rewrite
const InputRange = ({ className, min, max, range, step, disabled, prefix, suffix, pearling, onChange, controlAriaDescribedBy }) => {
    const b = styleBlock("inputrange");
    const [value, setValue] = useState({
        min,
        max,
        focused: null,
        editValue: "",
    });
    useEffect(() => {
        if (range) {
            setValue(Object.assign(Object.assign({}, value), { min: range[0], max: range[1] }));
        }
    }, range);
    function handleChange(e) {
        const newValue = Object.assign({}, value);
        if (newValue.focused) {
            newValue.editValue = e.target.value.replace(/[\D]*/g, "");
        }
        else {
            if (Array.isArray(e)) {
                newValue.min = e[0];
                newValue.max = e[1];
            }
            else {
                const updatedValue = e.target.name.slice(-3);
                newValue[updatedValue] = parseInt(e.target.value);
            }
        }
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange([newValue.min, newValue.max]);
    }
    function onBlurFocus(e) {
        const focused = e.target.name.slice(-3);
        const newValue = Object.assign({}, value);
        if (e.type === "focus") {
            newValue.editValue = "" + parseInt(e.target.value);
            newValue.focused = focused;
        }
        else if (e.type === "blur") {
            const resultingValue = value.editValue ? parseInt(value.editValue) : eval(focused);
            newValue[focused] = (focused === "min"
                ? resultingValue >= min && resultingValue < value.max
                : resultingValue > value.min && resultingValue <= max)
                ? resultingValue
                : eval(focused);
            newValue.editValue = "";
            newValue.focused = null;
        }
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange([newValue.min, newValue.max]);
    }
    return (React.createElement("div", { className: b.toString() + " " + className },
        React.createElement(Form.Label, { "aria-describedby": controlAriaDescribedBy, srOnly: true, htmlFor: "inputrangecustommin" }, "Min. hodnota"),
        React.createElement(Form.Control, { id: "inputrangecustommin", type: "phone", name: "inputrangecustommin", value: value.focused === "min" ? value.editValue : (prefix ? prefix : "") + value.min + (suffix ? suffix : ""), onFocus: onBlurFocus, onBlur: onBlurFocus, onChange: handleChange, tabIndex: 1, className: "px-0", autoComplete: "off" }),
        React.createElement(ReactSlider, { min: min, max: max, step: step !== null && step !== void 0 ? step : 1, minDistance: step !== null && step !== void 0 ? step : 0, value: [value.min, value.max], className: "slider", thumbClassName: "thumb", trackClassName: "track", pearling: pearling !== null && pearling !== void 0 ? pearling : true, disabled: disabled, onChange: handleChange }),
        React.createElement(Form.Label, { "aria-describedby": controlAriaDescribedBy, srOnly: true, htmlFor: "inputrangecustommax" }, "Max. hodnota"),
        React.createElement(Form.Control, { id: "inputrangecustommax", type: "phone", name: "inputrangecustommax", value: value.focused === "max" ? value.editValue : (prefix ? prefix : "") + value.max + (suffix ? suffix : ""), onFocus: onBlurFocus, onBlur: onBlurFocus, onChange: handleChange, tabIndex: 2, className: "px-0", autoComplete: "off" })));
};
export default InputRange;
//# sourceMappingURL=index.js.map